/**
 * ResumeMetric - Job Application Tracker
 * localStorage-backed CRUD for tracking job applications.
 * @module tools/applicationTracker
 */

const STORAGE_KEY = 'rm_job_apps';

function generateId() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2, 7);
}

export function getApplications() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
        return [];
    }
}

export function addApplication(app) {
    const apps = getApplications();
    const newApp = {
        id: generateId(),
        company: app.company || '',
        role: app.role || '',
        status: app.status || 'applied',
        dateApplied: app.dateApplied || new Date().toISOString().split('T')[0],
        followUpDate: app.followUpDate || '',
        salary: app.salary || '',
        notes: app.notes || '',
        url: app.url || '',
        createdAt: new Date().toISOString()
    };
    apps.unshift(newApp);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(apps));
    return newApp;
}

export function updateApplication(id, updates) {
    const apps = getApplications();
    const idx = apps.findIndex(a => a.id === id);
    if (idx === -1) return null;
    apps[idx] = { ...apps[idx], ...updates };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(apps));
    return apps[idx];
}

export function deleteApplication(id) {
    const apps = getApplications().filter(a => a.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(apps));
    return apps;
}

export function getStats(apps) {
    const statusCounts = {};
    apps.forEach(a => {
        statusCounts[a.status] = (statusCounts[a.status] || 0) + 1;
    });

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const needsFollowUp = apps.filter(a => {
        if (!a.followUpDate || a.status === 'rejected' || a.status === 'accepted') return false;
        return new Date(a.followUpDate) <= today;
    });

    return {
        total: apps.length,
        statusCounts,
        needsFollowUp: needsFollowUp.length,
        followUpList: needsFollowUp
    };
}

export const STATUSES = [
    { value: 'saved', label: 'Saved', color: '#94a3b8' },
    { value: 'applied', label: 'Applied', color: '#3b82f6' },
    { value: 'screening', label: 'Screening', color: '#8b5cf6' },
    { value: 'interview', label: 'Interview', color: '#f59e0b' },
    { value: 'offer', label: 'Offer', color: '#10b981' },
    { value: 'accepted', label: 'Accepted', color: '#059669' },
    { value: 'rejected', label: 'Rejected', color: '#ef4444' },
    { value: 'withdrawn', label: 'Withdrawn', color: '#6b7280' }
];
